(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nutrivora-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!window.NutrivoraAppSafeQuickAdd) {
    window.NutrivoraAppSafeQuickAdd = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-nv3-quick-add]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;

      const label = button.querySelector('span');
      const originalLabel = label.textContent;
      button.setAttribute('aria-busy', 'true');
      label.textContent = button.dataset.loadingLabel;

      try {
        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Cart request failed');
        label.textContent = button.dataset.addedLabel;
        window.setTimeout(() => { window.location.href = `${root}cart`; }, 450);
      } catch (error) {
        label.textContent = button.dataset.errorLabel;
        window.setTimeout(() => { label.textContent = originalLabel; }, 1800);
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
